import { render, staticRenderFns } from "./OrderDetailContent.vue?vue&type=template&id=27ae1e12&scoped=true&"
import script from "./OrderDetailContent.vue?vue&type=script&lang=js&"
export * from "./OrderDetailContent.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailContent.vue?vue&type=style&index=0&id=27ae1e12&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ae1e12",
  null
  
)

export default component.exports